import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ScenarioBar from "../components/ScenarioBar";
import { ROUTES } from "../utils/constants";
import { getScenarioNumByPath } from "../utils/helpers";
import { IconBuildingHospital, IconAlarm } from "@tabler/icons-react";
import flechaRetroceder from "../assets/left-arrow.svg";
import flechaAvanzar from "../assets/right-arrow.svg";

function Scenario1Intro({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  // Array de textos
  const texts = [
    "<h3 class='txtRed bold'>Un paciente con un cáncer urológico ha ingresado para una evaluación integral.</h3>El equipo médico tiene <strong>45 minutos</strong> para reunir toda la información diagnóstica necesaria, interpretar los resultados y definir el mejor enfoque terapéutico.",
    "<h3 class='txtRed bold'>Cada prueba completada: biopsia, imágenes por PET, análisis de laboratorio y estudios de laboratorio, desbloquea el siguiente reto en la sala.</h3></br>Cada decisión clínica <strong>correcta</strong> acerca al equipo al <strong>tratamiento preciso</strong>. Si se <strong>equivocan</strong> se restan puntos, y se reduce la ventana para iniciar el tratamiento más eficaz.​",
    "<h3 class='txtRed bold'>¿Podrás decidir antes de que el reloj llegue a cero?</h3>El tiempo no siempre corre en contra, pero en oncología urológica, cada minuto cuenta para preservar calidad de vida."
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < texts.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      // Último texto → ir a START_GAME
      navigate(ROUTES.START_GAME, { state: { activeScenario } });
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="h-100 bg5">
      <div className="container-fluid h-100">
        <div className="row h-100">
          {/* Columna izquierda: recuadro con textos y botones */}
          <div
            className="col-md-5 d-flex justify-content-start align-items-center ps-5 pt-5"
            style={{ marginBottom: "10vh" }}
          >
            <div className="d-flex flex-column align-items-start w-100 mt-3">
              <p
                className="position-relative txt20 mt-3 w-100"
                style={{
                  padding: "20px",
                  lineHeight: "1.6",
                  backgroundColor: "#FFF",
                  border: "1px solid #b1000d1f",
                  borderRadius: "8px",
                  minHeight: "270px",
                  overflow: "hidden",
                }}
              >
                <div
                    className="position-relative"
                    dangerouslySetInnerHTML={{ __html: texts[currentIndex] }}
                />
                <IconAlarm
                  size={100}
                  color="#000"
                  stroke={1}
                  className="position-absolute"
                  style={{
                    top: "-7px",
                    right: "0px",
                    opacity: 0.1,
                    pointerEvents: "none",
                  }}
                />
              </p>

              {/* Puntos indicadores */}
              <div className="d-flex justify-content-center align-items-center mt-2 w-100">
                {texts.map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      margin: "0 4px",
                      backgroundColor: idx === currentIndex ? "#d9534f" : "#ccc",
                    }}
                  ></div>
                ))}
              </div>

              {/* Botones navegación */}
              <div className="d-flex justify-content-between mt-3 w-100">
                {currentIndex > 0 ? (
                  <div className="d-flex justify-content-end align-items-center">
                    <button
                      onClick={handlePrev}
                      className="btn-main"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                      }}
                    >
                      <img
                        src={flechaRetroceder}
                        alt="Anterior"
                        style={{ maxWidth: "40px" }}
                      />
                    </button>
                    <div className="txt24 txtRed bold ms-3">
                      Anterior
                    </div>
                  </div>
                ) : (
                  <div style={{ width: "50px" }}></div> // hueco para alinear
                )}

                <div className="d-flex justify-content-end align-items-center">
                  <div className="txt24 txtRed bold me-3">
                    Siguiente
                  </div>
                  <button
                    onClick={handleNext}
                    className="btn-main"
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                    }}
                  >
                    <img
                      src={flechaAvanzar}
                      alt="Siguiente"
                      style={{ maxWidth: "40px" }}
                    />
                  </button>              
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7 d-flex justify-content-end align-items-center me-0 pe-0">
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} expanded />
    </div>
  );
}

export default injectIntl(Scenario1Intro);
